import { type Config } from 'tailwindcss';
import tailwindColors from 'tailwindcss/colors';
import tailwindTheme from 'tailwindcss/defaultTheme';

import tailwindPreset from '../../packages/tailwind-base/base-preset';
import styles from './src/components/utils/styles';

const config: Config = {
  presets: [tailwindPreset],
  content: [
    './src/**/*.{js,jsx,ts,tsx}',
    '../../packages/**/*.{js,ts,jsx,tsx}',
    '!../../**/node_modules/**/*',
  ],
  theme: {
    extend: {
      colors: {
        background: tailwindColors.white,
        brand: {
          DEFAULT: styles.colors.blue[500],
          'aa-white': styles.colors.blue[500],
          dark: styles.colors.blue[700],
          foreground: styles.colors.blue[600],
        },
        card: {
          DEFAULT: tailwindColors.white,
          foreground: styles.colors.gray[700],
        },
        foreground: {
          DEFAULT: styles.colors.gray[700],
          link: styles.colors.blue[500],
          headline: styles.colors.blue[500],
          xdark: styles.colors.gray[900],
        },
        popover: {
          DEFAULT: tailwindColors.white,
          foreground: styles.colors.gray[700],
        },
        primary: {
          DEFAULT: styles.colors.blue[500],
          hover: styles.colors.blue[700],
          foreground: tailwindColors.white,
        },
        secondary: {
          DEFAULT: styles.colors.blue[50],
          hover: styles.colors.blue[100],
          foreground: {
            DEFAULT: styles.colors.blue[500],
            aa: styles.colors.blue[500],
          },
        },
        muted: {
          DEFAULT: styles.colors.gray[50],
          foreground: {
            DEFAULT: styles.colors.gray[500],
            link: styles.colors.blue[500],
          },
        },
        accent: {
          DEFAULT: styles.colors.gray[50],
          foreground: styles.colors.gray[600],
        },
        destructive: {
          DEFAULT: '#DC2626',
          hover: '#B91C1C',
          foreground: tailwindColors.white,
        },
        border: styles.colors.gray[200],
        input: {
          DEFAULT: styles.colors.gray[500],
          background: tailwindColors.white,
          foreground: styles.colors.gray[700],
          placeholder: styles.colors.gray[500],
        },
        ring: styles.colors.blue[500],
        inverse: {
          DEFAULT: styles.colors.blue[900],
          foreground: tailwindColors.white,
        },
        cta: {
          DEFAULT: styles.colors.blue[500],
          foreground: tailwindColors.white,
          hover: styles.colors.blue[700],
        },
        chart: {
          DEFAULT: '#E76E50',
          1: '	#E76E50',
          2: '#2A9D90',
          3: '#274754',
          4: '	#E8C468',
          5: '#F4A462',
        },
      },
      borderColor: {
        DEFAULT: styles.colors.gray[200],
      },
      borderRadius: {
        interface: tailwindTheme.borderRadius.full,
      },
      boxShadow: {
        'top-lg':
          '0 -10px 15px -3px rgba(0, 0, 0, 0.1), 0 -4px 6px -4px rgba(0, 0, 0, 0.1)',
      },
      keyframes: {
        'accordion-down': {
          from: { height: '0' },
          to: { height: 'var(--radix-accordion-content-height)' },
        },
        'accordion-up': {
          from: { height: 'var(--radix-accordion-content-height)' },
          to: { height: '0' },
        },
      },
      animation: {
        'accordion-down': 'accordion-down 0.2s ease-out',
        'accordion-up': 'accordion-up 0.2s ease-out',
      },
      textTransform: {
        'button-case': 'button-case',
      },
    },
  },
  plugins: [
    ({ addUtilities }) => {
      const newTextTransforms = {
        '.button-case': {
          textTransform: 'none',
        },
      };

      addUtilities(newTextTransforms, ['responsive', 'hover']);
    },
  ],
};

export default config;
